module.exports = __webpack_public_path__ + "static/img/萌乐天.b4fb168a.png";